import dayjs from "dayjs";
import styled from "styled-components";

import { useBIMClass, useParameter } from "../../../../modules/shared-entities";
import { Card, CardFace3, CardSkeleton, LetterBackdrop } from "../../../../modules/ui-kit";
import objectIDToDate from "../../utils/objectIDToDate";

import type { ElementType } from "react";

export default function CardX(props) {
    const { bimClassID, id, parameterID, revitBuiltInParameterID, revitSharedParameterDefinition, ...restProps } = props;

    const parameterQuery = useParameter(parameterID);
    const bimClassQuery = useBIMClass(bimClassID);

    if (parameterQuery.loading || bimClassQuery.loading) return <CardSkeleton />;

    let Attributes: ElementType = () => undefined;
    if (revitBuiltInParameterID) Attributes = BuiltInParameterAttributes;
    if (revitSharedParameterDefinition) Attributes = SharedParameterAttributes;

    return (
        <Card { ...restProps }>
            <LetterBackdrop>RPT</LetterBackdrop>
            <CardFace3>
                <span className="name fluid-accent">{ parameterQuery.data.parameter.name[0].text }</span>
                <span>{ bimClassQuery.data?.bimClass?.data?.name?.[0]?.text ?? "" }</span>
                <span>{ dayjs(objectIDToDate(id)).format("YYYY-MM-DD HH:mm:ss") }</span>
            </CardFace3>
            <Attributes { ...(revitBuiltInParameterID ? { id: revitBuiltInParameterID } : revitSharedParameterDefinition) } />
        </Card>
    );
}

const StyledAttributes = styled.div`
    display: grid;
    gap: 8px;
    grid-auto-flow: column;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    opacity: .4;
`;

function BuiltInParameterAttributes(props) {
    return (
        <StyledAttributes>
            <span>{ props.id }</span>
        </StyledAttributes>
    );
}

function SharedParameterAttributes(props) {
    return (
        <StyledAttributes>
            <span>{ props.instance ? "instance" : "type" }</span>
            <span>{ props.modifiable ? "modifiable" : "immutable" }</span>
            <span>{ props.visible ? "visible" : "hidden" }</span>
            <span style={ { textAlign: "right" } }>{ props.group }</span>
            <span style={ { textAlign: "right" } }>{ props.type }</span>
        </StyledAttributes>
    );
}
